import { Component, Input, OnInit } from '@angular/core';

// Models
import { AccountMessage } from 'src/app/modules/account/models/user';

@Component({
  selector: 'app-accounts-messages',
  templateUrl: './accounts-messages.component.html',
  styleUrls: ['./accounts-messages.component.scss']
})
export class AccountsMessagesComponent implements OnInit {
  @Input() public messages: Array<AccountMessage> = [];

  constructor() {}

  ngOnInit(): void {}
}
